<template>
  <div class="station-main">
      <div class="self-stations">
        <div class="create-station" @click="handleCreateStation">
          <i
            class="el-icon-plus icon create-icon"
          />
          <label>新建微站</label>
        </div>
        <template v-for="(x,index) in associations">
          <div class="self-station" :key="index" v-if="index<7" @click="handleActionReplace($event,x.id)">
            <div class="top">
              <img :src="preViewUrl+x.avatar">
              <label>{{ x.name }}</label>
            </div>
            <div class="bottom">
              <label @click="$emit('edit',x.id)">编辑</label>
              <label @click="$emit('show',x.id)">查看</label>
            </div>
          </div>
        </template>
      </div>
    <el-table
      style="margin-top: 20px"
      :data="AssociationPosts"
      ref="refTable"
      @row-click="expandRow"
    >
      <el-table-column type="expand">
        <template slot-scope="{row}">
          <el-form label-position="left" label-width="110px">
            <el-form-item label="社团名称">
              {{row.Association.name}}
            </el-form-item>
            <el-form-item label="帖子内容">
              {{row.content}}
              <ul @click="previewWord({type:'image',url:x.url})" v-for="x in row.Thumbs" style="width: 200px" class="el-upload-list el-upload-list--text">
                <li tabindex="0" class="el-upload-list__item is-success">
                  <a class="el-upload-list__item-name">
                    <i class="el-icon-document"></i>
                    {{x.name}}
                  </a>
                </li>
              </ul>
            </el-form-item>
            <el-form-item label="发布时间">
              {{ row.created_at|parseTime}}
            </el-form-item>
            <el-form-item label="评论">
              {{row.comment_sum}}
            </el-form-item>
            <el-form-item label="点赞">
              {{row.like_sum}}
            </el-form-item>
            <el-form-item label="浏览">
              {{row.read_sum}}
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="社团名称" width="200px" show-overflow-tooltip align="center" prop="Association.name"></el-table-column>
      <el-table-column label="帖子内容" width="200px" show-overflow-tooltip align="center" prop="content"></el-table-column>
      <el-table-column label="发布时间" show-overflow-tooltip width="150px" align="center">
        <template slot-scope="{row}">
          {{ row.created_at|parseTime}}
        </template>
      </el-table-column>
      <el-table-column label="评论" width="100px" align="center">
        <template slot-scope="{row}">
          {{row.comment_sum}}
        </template>
      </el-table-column>
      <el-table-column label="点赞" width="100px" align="center" prop="like_sum"></el-table-column>
      <el-table-column label="浏览" prop="read_sum" width="100px" align="center"></el-table-column>
      <el-table-column label="操作"  align="center">
        <template slot-scope="{row}">
          <axj-button-v2
            button-color="bread"
            button-size="medium"
            button-icon="del1"
            @click="$emit('delete',row)"
          ></axj-button-v2>
        </template>
      </el-table-column>
    </el-table>
    <axj-file-preview
      :show-preview.sync="preview.show"
      :preview-file-type="preview.previewFileType"
      :preview-files="preview.previewFiles"
    />
  </div>
</template>

<script>
import commonModels from '@/common/models/common-models'
export default {
  name: "station-main",
  props:{
    associations:{
      type:Array,
      default:[]
    },
    AssociationPosts:{
      type:Array,
      default:[]
    }
  },
  data(){
    return{
      preview:{
        show:false,
        previewFileType:'word',
        previewFiles:[]
      },
    }
  },
  watch:{
    associations(v){
      this.$nextTick(()=>{
        let allStations=document.body.querySelector('.station-main').querySelectorAll('.self-station')
        allStations[0].className='self-station active'
      })
    }
  },
  mounted() {
    this.$nextTick(()=>{

    })
  },
  computed:{
    preViewUrl(){
      return this.$common.SystemConfig.PreViewUrl
    }
  },
  filters:{
    parseTime(time){
      return commonModels.formatTime(time,'Y/M/D h:m:s')
    },
  },
  methods:{
    expandRow(row,index,e){
      let target=e.target
      if(target.className.indexOf('cell')==0||target.className.indexOf('el-tag')==0||target.className.indexOf('el-table')==0){
        this.$refs.refTable.toggleRowExpansion(row)
        return
      }
    },
    previewWord(x){
      this.preview.previewFileType=x.type
      this.preview.previewFiles=[]
      this.preview.previewFiles.push({
        url:x.url
      })
      this.preview.show=true
    },
    handleCreateStation(){
      this.$emit('create')
    },
    handleActionReplace(event,associationid){
      let allStations=document.body.querySelector('.station-main').querySelectorAll('.self-station')
      for(let x=0;x<allStations.length;x++){
        allStations[x].className='self-station'
      }
      let paths=event.path
      for(let x=0;x<paths.length;x++){
        if(paths[x]&&paths[x].className&&paths[x].className.toString().indexOf('self-station')!=-1&&paths[x].className.toString().indexOf('self-stations')==-1){
          paths[x].className="self-station active"

        }
      }
      this.$emit("associationReplace",associationid)
    }
  }
}
</script>

<style slot-scope lang="scss">
.station-main{
  .self-stations{
    display: flex;
    .create-station{
      width: 90px;
      border-radius: 5px;
      cursor: pointer;
      height: 90px;
      background: #00adb5;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      box-shadow: 0px 4px 27px rgba(0, 0, 0, 0.02);
      .create-icon{
        font-size: 30px;
        color: white;
      }
      label{
        font-size: 12px;
        color: white;
        cursor: pointer;
      }
    }
    .self-station.active{
      width: 105px;
      height: 105px;
      border: 1px solid #00adb5;
    }
    .self-station{
      margin-left: 20px;
      width: 90px;
      height: 90px;
      background-color: #ffffff;
      border-radius: 5px;
      box-shadow: 0px 4px 27px rgba(0, 0, 0, 0.02);
      cursor: pointer;
      display: flex;
      flex-direction: column;
      align-items: center;
      div.top{
        img{
          width: 35px;
          height: 35px;
          border-radius: 5px;
        }
        label{
          text-overflow: ellipsis;
          font-size: 12px;
          cursor: pointer;
          width: 70px;
          text-align: center;
          overflow:hidden;
          display: block;
          white-space:nowrap;
        }
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content:space-around;
        flex: 3;
      }
      div.bottom{
        flex: 1;
        label{
          font-size: 12px;
          color: #00adb5;
          cursor: pointer;
        }
      }
    }
    .self-station:nth-child(2){
      margin-left: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/axj-information/axj-station/component/station-main/index.vue